import { User } from "@finway-group/shared/lib/models";

export const createCompanyIdCookieName = (user?: User) => `companyId-${user?.tenantId}`